module.exports = __webpack_public_path__ + "media/01.05cf0a07.pdf";